module.exports = "#define GLSLIFY 1\n#ifdef USE_COLOR\n\n\tvColor.xyz = color.xyz;\n\n#endif"